import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

const Progress = styled.svg`
  transform: rotate(-90deg);
`

const ProgressMeter = styled.circle`
  fill: none;
  stroke: #dddddd;
`

const ProgressValue = styled.circle`
  fill: none;
  stroke: #28618d;
  stroke-linecap: square;
`

const RADIUS = 12
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

const UploadProgressIndicator = ({ progress: value }) => {
  const progress = value / 100
  const dashoffset = CIRCUMFERENCE * (1 - progress)

  return (
    <Progress width="30" height="30" viewBox="0 0 30 30">
      <ProgressMeter cx="15" cy="15" r="12" strokeWidth="3" />
      <ProgressValue
        cx="15"
        cy="15"
        r="12"
        strokeWidth="3"
        strokeDashoffset={dashoffset}
        strokeDasharray={CIRCUMFERENCE}
      />
    </Progress>
  )
}

UploadProgressIndicator.defaultProps = {
  progress: 0,
}

UploadProgressIndicator.propTypes = {
  progress: PropTypes.number,
}

export default UploadProgressIndicator
